/**
 * I tipi dei documenti del paziente, come si scrivono a schermo.
 *
 * UN ELENCO SOLO (6/10/2026). Ce n'erano due: quello della linguetta
 * Documenti e quello della ricerca nei documenti. Il secondo aveva
 * «referto», il primo no, e i referti caricati - quelli che arrivano da un
 * laboratorio - comparivano nella linguetta con l'etichetta «Altro».
 *
 * L'elenco dei tipi lo decide il database (il vincolo documenti_tipo_check
 * di documenti_tab): chi ne aggiunge uno lo aggiunge anche qui, nello stesso
 * commit. La prova a browser (frontend/scripts/provaDocumentiSchermata.js)
 * legge il vincolo e pretende un'etichetta sua per ogni tipo.
 */
export const TIPI_DOCUMENTO = {
    anagrafica: { testo: 'Anagrafica', classe: 'tipo-anagrafica' },
    privacy: { testo: 'Privacy', classe: 'tipo-privacy' },
    foto: { testo: 'Consenso foto', classe: 'tipo-foto' },
    fea: { testo: 'Consenso FEA', classe: 'tipo-fea' },
    prestazione: { testo: 'Consenso procedura', classe: 'tipo-prestazione' },
    attestazione: { testo: 'Attestazione', classe: 'tipo-attestazione' },
    referto: { testo: 'Referto', classe: 'tipo-referto' },
    altro: { testo: 'Altro', classe: 'tipo-altro' },
};
